<div class="total-padding" #invisiblePadding></div>
<div class="scrollable-content" #content>
    <ng-content></ng-content>
</div>